import IndexFooter from 'pages/IndexPage/IndexFooter';
import IndexHeader from 'pages/IndexPage/IndexHeader';
import React from 'react';
import SubscriptionHero from './SubscriptionHero';

const SubscriptionUpgradePage = () => {
  return (
    <div className="su-min-vh100 su-column">
      <IndexHeader queryParams="" showSignInButton={false} />
      <SubscriptionHero />
      <IndexFooter />
    </div>
  );
};

export default SubscriptionUpgradePage;
